/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerInsuranceType } from './ScreenerInsuranceType';
import {
    ScreenerInsuranceTypeFromJSON,
    ScreenerInsuranceTypeFromJSONTyped,
    ScreenerInsuranceTypeToJSON,
    ScreenerInsuranceTypeToJSONTyped,
} from './ScreenerInsuranceType';

/**
 * 
 * @export
 * @interface FacilityInnTypes
 */
export interface FacilityInnTypes {
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    inn_types: Array<ScreenerInsuranceType>;
    /**
     * 
     */
    network_status: FacilityInnTypesNetworkStatusEnum;
}


/**
 * @export
 */
export const FacilityInnTypesNetworkStatusEnum = {
    InNetwork: 'in_network',
    OutOfNetwork: 'out_of_network',
} as const;
export type FacilityInnTypesNetworkStatusEnum = typeof FacilityInnTypesNetworkStatusEnum[keyof typeof FacilityInnTypesNetworkStatusEnum];


/**
 * Check if a given object implements the FacilityInnTypes interface.
 */
export function instanceOfFacilityInnTypes(value: object): value is FacilityInnTypes {
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('inn_types' in value) || value['inn_types'] === undefined) return false;
    if (!('network_status' in value) || value['network_status'] === undefined) return false;
    return true;
}

export function FacilityInnTypesFromJSON(json: any): FacilityInnTypes {
    return FacilityInnTypesFromJSONTyped(json, false);
}

export function FacilityInnTypesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacilityInnTypes {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
        'inn_types': ((json['inn_types'] as Array<any>).map(ScreenerInsuranceTypeFromJSON)),
        'network_status': json['network_status'],
    };
}

export function FacilityInnTypesToJSON(json: any): FacilityInnTypes {
    return FacilityInnTypesToJSONTyped(json, false);
}

export function FacilityInnTypesToJSONTyped(value?: FacilityInnTypes | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_id': value['facility_id'],
        'inn_types': ((value['inn_types'] as Array<any>).map(ScreenerInsuranceTypeToJSON)),
        'network_status': value['network_status'],
    };
}

